import { render, staticRenderFns } from "./namespaces.vue?vue&type=template&id=2b7b9d99&"
import script from "./namespaces.vue?vue&type=script&lang=js&"
export * from "./namespaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports